import { Ability } from '@casl/ability'
import { isUserLoggedIn, getUserType } from '../../auth'
import { initialAbility } from './initialAbility'
import ABILITIES from "./roleAbilities"

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this


const loggedIn = isUserLoggedIn()
// ! This usertype must be taken from the backend result 
const { userType } = getUserType()
const existingAbility = loggedIn ? ABILITIES[userType] : null

export default new Ability(existingAbility || initialAbility)
